import { apiService } from "./api";
import { Asset, AssetCreate, AssetUpdate, AssetSummary, DepreciationEntry, AssetCategoryOption } from "../types/assets";

class AssetService {
    async getSummary(): Promise<AssetSummary> {
        return apiService.get<AssetSummary>("/assets/summary");
    }

    async getCategories(): Promise<AssetCategoryOption[]> {
        return apiService.get<AssetCategoryOption[]>("/assets/categories");
    }

    async listAssets(params?: {
        status?: string;
        category?: string;
        purchase_date_from?: string;
        purchase_date_to?: string;
        skip?: number;
        limit?: number;
    }): Promise<Asset[]> {
        return apiService.get<Asset[]>("/assets", { params });
    }

    async getAsset(assetId: string): Promise<Asset> {
        return apiService.get<Asset>(`/assets/${assetId}`);
    }

    async createAsset(data: AssetCreate): Promise<Asset> {
        return apiService.post<Asset>("/assets", data);
    }

    async updateAsset(assetId: string, data: AssetUpdate): Promise<Asset> {
        return apiService.put<Asset>(`/assets/${assetId}`, data);
    }

    async deleteAsset(assetId: string): Promise<void> {
        return apiService.delete(`/assets/${assetId}`);
    }

    async getDepreciationSchedule(assetId: string): Promise<DepreciationEntry[]> {
        return apiService.get<DepreciationEntry[]>(`/assets/${assetId}/schedule`);
    }
}

export const assetService = new AssetService();
